import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {getVipUser} from '../../redux/user.redux'
import {getUnReadNum} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'
import {getInFoFn} from '../../redux/chatuser.redux.js'
import './third-info.css'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,getInFoFn}
) 



class ThirdInfo extends React.Component{
	constructor(props){
		super(props)
		this.state={
			
		}

		
		
		
	}
	componentDidMount(){
	
		
	}
	componentWillReceiveProps(nextProps){

		
	}
	copyContentH5 (content){
	    var copyDom = document.createElement('div');
	    copyDom.innerText=content;
	    copyDom.style.position='absolute';
	    copyDom.style.top='0px';
	    copyDom.style.right='-9999px';
	    document.body.appendChild(copyDom);
	    //创建选中范围
	    var range = document.createRange();
	    range.selectNode(copyDom);
	    //移除剪切板中内容
	    window.getSelection().removeAllRanges();
	    //添加新的内容到剪切板
	    window.getSelection().addRange(range);
	    //复制
	    var successful = document.execCommand('copy');
	    copyDom.parentNode.removeChild(copyDom);
	    alert('复制成功')
	    try{
	        var msg = successful ? "successful" : "failed";
	        console.log('Copy command was : ' + msg);
	    } catch(err){
	        console.log('Oops , unable to copy!');
	    }
	}
	copyCon () {
		
		this.copyContentH5(this.props.userlist.displayAccount)
	}
	handleLogout(){		
		const MyOrigin = window.location.origin
		this.pathname = MyOrigin +''+ '/third-login'
		console.log(this.pathname)
		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
	}
	render(){
		var igame = ''
		if(this.props.userlist.thirdPartyId=='352'){
			igame = '龙之谷weGame'
		}else if(this.props.userlist.thirdPartyId=='389'){
			igame = '龙之谷steam'
		}
		return(
			<div className="third-info">

				{ 
					this.props.userlist.displayAccount&&<div>
						<div className="detail">
							<div>{igame}渠道编码</div>

								<span>{this.props.userlist.displayAccount}</span>
					 		</div>
							<div className="third-btn"><button className="button1" onClick={()=>this.copyCon()}></button><button className="button2" onClick={()=>this.handleLogout()}></button>
						</div>
					</div>
				}
			</div>

			
		)
	}
}
export default ThirdInfo


// WEBPACK FOOTER //
// ./src/container/third-info/third-info.js